module.exports = __webpack_public_path__ + "img/faq-logo-france-express.fc046223.png";